import Actions from 'actions';

const initialState = Object.freeze({});

const userClassifications = (state = initialState, action) => {
  const { classificationType } = action;

  switch (action.type) {
    case Actions.FETCH_USER_CLASSIFICATIONS_REQUEST:
      return {
        ...state,
        [action.params.type]: {
          ...state[action.params.type],
          isLoading: true,
          error: null,
        },
      };
    case Actions.FETCH_USER_CLASSIFICATIONS_SUCCESS:
      return {
        ...state,
        [classificationType]: {
          data: action.data,
          isLoading: false,
          error: null,
        },
      };
    case Actions.FETCH_USER_CLASSIFICATIONS_FAIL:
      return {
        ...state,
        [classificationType]: {
          ...state[classificationType],
          isLoading: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
};

export default userClassifications;
